export default __webpack_public_path__ + "static/media/pot4.3cb6bd76.svg";